import React from "react";

export const Dialog = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4"
      style={{ zIndex: 1100 }}
    >
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-md w-full p-6">
        {children}
      </div>
    </div>
  );
};

export const DialogTitle = ({ children }) => (
  <h3 className="text-lg font-semibold mb-2">{children}</h3>
);

export const DialogDescription = ({ children }) => (
  <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">{children}</p>
);

export const DialogFooter = ({ children }) => (
  <div className="flex justify-end gap-2 mt-4">{children}</div>
);
